import axios from 'axios'
import { stringify } from 'qs'
import { persistToken } from '../../../lib/token'
import base from '../../base'
import { LOGIN, LOGOUT } from './mutation-types'
import resource from './resource'

export default {
  login({ commit }, payload) {
    payload.client_id = '2'
    const data = stringify(payload)
    const config = {
      url: resource,
      method: 'POST',
      baseURL: base.slice(0, -4),
      data
    }

    return axios(config).then(({ data }) => {
      axios.defaults.headers.common[
        'Authorization'
      ] = `bearer ${data.access_token}`
      persistToken(data)
      commit(LOGIN, data)
    })
  },

  refreshToken({ commit }, payload) {
    const grant_type = 'refresh_token'
    const { refresh_token } = payload
    const client_id = '2'
    const config = {
      url: resource,
      method: 'POST',
      baseURL: base.slice(0, -4),
      data: stringify({ refresh_token, grant_type, client_id })
    }
    return axios(config).then(({ data }) => {
      const { access_token } = data
      axios.defaults.headers.common['Authorization'] = `bearer ${access_token}`
      persistToken(data)
      commit(LOGIN, data)
      return access_token
    })
  },

  setUserData({ commit }, payload) {
    commit(LOGIN, payload)
  },

  logout({ commit }) {
    axios.defaults.headers.common['Authorization'] = undefined
    axios.defaults.params['instituicao'] = undefined
    persistToken({})
    commit(LOGOUT)
  }
}
